import { API_CALL } from 'actions/actionConstants'
import { FETCH_MERCHANDISE_SEARCH_TYPEAHEAD } from 'actions/apiActionConstants'
import { AppAction } from 'actions/types/ActionTypes'
import getMerchandiseSearchTypeahead from 'api/merchandise/getMerchandiseSearchTypeahead'

function fetchMerchandiseSearchTypeahead(query: string): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    if (state.merchandise.merchandiseSearchTypeahead[query]) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_MERCHANDISE_SEARCH_TYPEAHEAD,
      request: () => getMerchandiseSearchTypeahead(query),
      key: query,
    })
  }
}

export default fetchMerchandiseSearchTypeahead
